import { createQueryKeyStore } from "@lukemorales/query-key-factory";

export const symptomTagKeys = createQueryKeyStore({
  symptomTag: {
    list: null,
  },
});
